import CareerPlanDocumentPage from "./_CareerPlanDocumentPage";

export default function NewCareerPlanDocumentPage() {
  return <CareerPlanDocumentPage mode="create" />;
}
